exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3thec_VYHHwwMPGCkV6wYA,\n._1U5gkDtux-EzWt8f4AGqFb {\n  font-weight: 500;\n  font-family: \"sofia-pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  box-sizing: border-box;\n}\n\n._3thec_VYHHwwMPGCkV6wYA {\n  margin: 0;\n}\n\n._1U5gkDtux-EzWt8f4AGqFb {\n  padding: 0;\n}\n", ""]);

// exports
exports.locals = {
	"bigBorderRadius": "8px",
	"defaultBorderRadius": "6px",
	"small": "0.5rem",
	"medium": "1rem",
	"large": "2.4rem",
	"vru": "0.5rem",
	"-vru": "-0.5rem",
	"gutter": "0.5rem",
	"m0": "_3thec_VYHHwwMPGCkV6wYA",
	"p0": "_1U5gkDtux-EzWt8f4AGqFb"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/style/space.css
 ** module id = 1
 ** module chunks = 0
 **/